<script context="module">
  import { subscribe } from '../helpers/subscribe'

  export class ModalHandler {
    constructor() {
      this.data = {
        open: false,
        title: null,
        subtitle: null,
        status: null,
      }
    }
    store() {
      return this._store = subscribe()
    }
    action() {
      if (this.data.success) {
        window.location.reload()
      }
      this.data.open = !this.data.open ? true : false
      this._store.set(this.data)
    }
    outsideClick() {
      if (this.data.open) {
        this.action()
      }
    }
  }
</script>

<script>
  import { fade, fly } from 'svelte/transition'
  import OutClick from 'svelte-outclick'
  
  export let columns, store, handler, open

  if (open) {
    let data = handler.data
    data.open = true
    store.set(data)
  }
</script>

{#if $store.open}
  <div class="modal {$store.status ? $store.status : ''}" in:fade={{ duration: 200 }} out:fade={{ duration: 300 }}>
    {#if $store.open}
      <OutClick
        excludeByQuerySelector={['.mobile-menu-close .icon']}
        on:outclick={handler.outsideClick()}
      >
        <div class="card columns_{columns}" transition:fly={{ y: 100, duration: 200 }}>
          {#if $store.title}
            <h1>
              {$store.title}
            </h1>
          {/if}
          {#if $store.subtitle}
            <p class="subtitle">
              {$store.subtitle}
            </p>
          {/if}
          <div class="btn">
            <button on:click={handler.action.bind(handler)}>
              Fechar
            </button>
          </div>
        </div>
      </OutClick>
    {/if}
  </div>
{/if}

<style lang="scss">
  @import '../scss/media-sizes';
  .btn {
    text-align: center;
    margin-top: 24px;
  }
  button {
    text-transform: uppercase;
    color: #000;
    background-color: #fff;
    font-family: 'myriad-pro', sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 16px;
    padding: 9px 30px;
    border-radius: 19px;
    cursor: pointer;
  }
  .modal {
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0,.5);
    display: flex;
    justify-content: center;
    align-items: flex-start;
    overflow-y: auto;
    padding: 120px 0;
  }
  .card {
    border-radius: 12px;
    padding: 24px;
    padding-top: 48px;
    background-color: #e93882;
    font-family: 'myriad-pro', sans-serif;
    font-weight: 500;
    font-style: normal;
    &.columns_1 {
      width: 420px;
    }
    &.columns_2 {
      width: 840px;
    }
    h1 {
      color: #fff;
      text-align: center;
      font-size: 20px;
      margin-bottom: 12px;
      font-weight: 500;
      text-transform: uppercase;
    }
    .subtitle {
      color: #fff;
      text-align: center;
      font-size: 18px;
    }
  }
  @media screen and (max-width: $mediaQueryMid) {
    .modal {
      padding: 60px 18px;
    }
    .card {
      padding: 48px 24px;
      &.columns_1 {
        width: 100%;
      }
      &.columns_2 {
        width: 100%;
      }
    }
  }
</style>